import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { VoterAuthProvider } from './contexts/VoterAuthContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { PartyAuthProvider } from './contexts/PartyAuthContext';

import VoterLogin from './voter/VoterLogin';
import VoterDashboard from './voter/VoterDashboard';
import CastVote from './voter/CastVote';
import Confirmation from './voter/Confirmation';
import VoterHistory from './voter/VoterHistory';

import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import Candidates from './admin/Candidates';
import Parties from './admin/Parties';
import Voters from './admin/Voters';
import Election from './admin/Election';

import PartyLogin from './party/PartyLogin';
import PartyDashboard from './party/PartyDashboard';
import PartyCandidates from './party/PartyCandidates';
import PartyAnalytics from './party/PartyAnalytics';

import Results from './public/Results';
import ConstituencyResults from './public/ConstituencyResults';

import './index.css';

export default function App() {
  return (
    <BrowserRouter>
      <VoterAuthProvider>
        <AdminAuthProvider>
          <PartyAuthProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/results" replace />} />

              <Route path="/vote/login" element={<VoterLogin />} />
              <Route path="/vote/dashboard" element={<VoterDashboard />} />
              <Route path="/vote/cast" element={<CastVote />} />
              <Route path="/vote/confirmation" element={<Confirmation />} />
              <Route path="/vote/history" element={<VoterHistory />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/candidates" element={<Candidates />} />
              <Route path="/admin/parties" element={<Parties />} />
              <Route path="/admin/voters" element={<Voters />} />
              <Route path="/admin/election" element={<Election />} />

              <Route path="/party/login" element={<PartyLogin />} />
              <Route path="/party/dashboard" element={<PartyDashboard />} />
              <Route path="/party/candidates" element={<PartyCandidates />} />
              <Route path="/party/analytics" element={<PartyAnalytics />} />

              <Route path="/results" element={<Results />} />
              <Route path="/results/constituency/:id" element={<ConstituencyResults />} />
            </Routes>
          </PartyAuthProvider>
        </AdminAuthProvider>
      </VoterAuthProvider>
    </BrowserRouter>
  );
}
